<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-tabs
                v-model="tab"
                :vertical="$vuetify.breakpoint.mdAndDown"
                color="secondary"
                class="d-flex"
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="text-capitalize d-flex justify-md-center px-3 flex-column"
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "SupplierManagement",

    data() {
        return {
            tab: this.$route.path,
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        tabs() {
            let arr = [];

            arr.push({
                    name: { el: "Προμηθευτές ", en: "suppliers", it: "Fornitori " },
                    to: `/${this.lang}/loyaltyPanel/supplier-management/supplier`,
                });
                if (this.getPermission('suppliers.notification_message.read')) {
                    arr.push({
                    name: { el: "Μήνυμα", en: "message", it: "Messaggio" },
                    to: `/${this.lang}/loyaltyPanel/supplier-management/message`,
                });
                }
            
                
            return arr;
        },
    },
    methods: {
        ...mapActions(["getPermission"])
    },
    watch: {
        $route: {
            immediate: true,
            handler(val) {
                if (val.path === `/${this.lang}/loyaltyPanel/supplier-management`) {
                    this.$router.push(
                        `/${this.lang}/loyaltyPanel/supplier-management/supplier`
                    );
                }
            },
        },
    },
};
</script>
